
import { useNavigate } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
  alt: string;
  path: string;
}

const ServiceCard = ({ title, description, image, alt, path }: ServiceCardProps) => {
  const navigate = useNavigate();
  
  return (
    <div
      className="bg-[#222222] p-4 sm:p-6 rounded-lg shadow-lg h-full cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl group"
      onClick={() => navigate(path)}
    >
      <div className="mb-3 sm:mb-4 h-36 sm:h-48 overflow-hidden rounded-lg">
        <img
          src={image}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
      </div>
      <h3 className="text-lg sm:text-xl font-semibold mb-2 text-accent-light transition-colors group-hover:text-accent line-clamp-2">
        {title}
      </h3>
      <p className="text-sm sm:text-base text-gray-400 transition-colors group-hover:text-gray-300 line-clamp-3">
        {description}
      </p>
    </div>
  );
};

export default ServiceCard;
